import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M29 3.65v24.694a8.6 8.6 0 0 1-1.588 1.478L6.517 1.165C8.64.411 12.352.032 16 0c3.75.033 7.567.432 9.691 1.263 1.43.555 2.507 1.44 3.31 2.387",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m6 5.942-1.236.683L5 5.178 4 4.153l1.382-.211L6 2.625l.618 1.317L8 4.152 7 5.179l.236 1.447zm2.667 3.625-1.237.683.237-1.447-1-1.025 1.381-.211.618-1.317.619 1.317 1.381.21-1 1.026.237 1.447zm2.667 3.625-1.237.683.237-1.447-1-1.025 1.382-.211.618-1.317.617 1.317 1.383.21-1 1.026.236 1.447zM14 16.817l-1.236.683.236-1.447-1-1.025 1.382-.211L14 13.5l.618 1.317 1.382.21-1 1.026.236 1.447zm2.667 3.625-1.237.683.236-1.447-1-1.025 1.383-.211.617-1.317.619 1.317 1.381.21-1 1.026.237 1.447zm2.667 3.625-1.237.683.236-1.447-1-1.025 1.383-.211.617-1.317.619 1.317 1.381.21-1 1.026.237 1.447zM22 27.692l-1.236.683.236-1.447-1-1.025 1.382-.211.618-1.317.618 1.317 1.382.21-1 1.026.236 1.447z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagBih = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagBih_default = SvgFlagBih;

export { FlagBih_default as default };
